"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAccountNetworkInfo = exports.avoidDups = void 0;
var flow_1 = __importDefault(require("lodash/flow"));
var bignumber_js_1 = require("bignumber.js");
var wallet_btc_1 = require("./wallet-btc");
var speeds = ["fast", "medium", "slow"];
function avoidDups(nums) {
    nums = nums.slice(0);
    for (var i = nums.length - 2; i >= 0; i--) {
        if (nums[i + 1].gte(nums[i])) {
            nums[i] = nums[i + 1].plus(1);
        }
    }
    return nums;
}
exports.avoidDups = avoidDups;
function getAccountNetworkInfo(account) {
    return __awaiter(this, void 0, void 0, function () {
        var walletAccount, rawFees, relayFee, feesPerByte, feeItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    walletAccount = (0, wallet_btc_1.getWalletAccount)(account);
                    return [4 /*yield*/, walletAccount.xpub.explorer.getFees()];
                case 1:
                    rawFees = _a.sent();
                    return [4 /*yield*/, walletAccount.xpub.explorer.getRelayFee()];
                case 2:
                    relayFee = _a.sent();
                    feesPerByte = (0, flow_1["default"])([
                        // Remove the 'last_updated' key
                        Object.entries,
                        function (entries) { return entries.filter(function (_a) {
                            var _b = __read(_a, 1), key = _b[0];
                            return !isNaN(key);
                        }); },
                        // Reconstruct the array with only the values
                        Object.fromEntries,
                        Object.values,
                        // Safety against invalid data
                        function (f) { return f.filter(function (f) { return f != null && typeof f === "number"; }); },
                        // Normalize values
                        function (f) {
                            return f.map(function (f) {
                                return new bignumber_js_1.BigNumber(f).div(1000).integerValue(bignumber_js_1.BigNumber.ROUND_CEIL);
                            });
                        },
                        avoidDups,
                    ])(rawFees);
                    if (feesPerByte.length !== 3) {
                        throw new Error("cardinality of feesPerByte should be exactly 3");
                    }
                    // Fix fees if suggested fee is too low, this is only for viacoin/decred because the fees backend endpoint is broken
                    if ((account.currency.id === "viacoin" ||
                        account.currency.id === "decred" ||
                        account.currency.id === "qtum") &&
                        feesPerByte[2].toNumber() < Math.ceil(relayFee * 100000)) {
                        feesPerByte[2] = new bignumber_js_1.BigNumber(Math.ceil(relayFee * 100000)).plus(2);
                        feesPerByte[1] = feesPerByte[2].plus(1);
                        if (feesPerByte[1].plus(1).gt(feesPerByte[0])) {
                            feesPerByte[0] = feesPerByte[1].plus(1);
                        }
                    }
                    feeItems = {
                        items: feesPerByte.map(function (feePerByte, i) { return ({
                            key: String(i),
                            speed: speeds[i],
                            feePerByte: feePerByte
                        }); }),
                        defaultFeePerByte: feesPerByte[Math.floor(feesPerByte.length / 2)] || new bignumber_js_1.BigNumber(0),
                        relayFee: relayFee
                    };
                    return [2 /*return*/, {
                            family: "bitcoin",
                            feeItems: feeItems
                        }];
            }
        });
    });
}
exports.getAccountNetworkInfo = getAccountNetworkInfo;
//# sourceMappingURL=getAccountNetworkInfo.js.map